import { ChevronDown } from 'lucide-react';
import { useState } from 'react';
import { cn } from '@/lib/utils';

interface CollapsibleSectionProps {
	label: string;
	/** Optional hint shown next to the label when collapsed (e.g. "3 selected") */
	hint?: string;
	/** Start expanded. Default: false */
	defaultOpen?: boolean;
	children: React.ReactNode;
}

export function CollapsibleSection({
	label,
	hint,
	defaultOpen = false,
	children,
}: CollapsibleSectionProps) {
	const [open, setOpen] = useState(defaultOpen);

	return (
		<div className="border-t border-line-1 pt-3">
			<button
				type="button"
				onClick={() => setOpen((o) => !o)}
				className="flex w-full cursor-pointer items-center justify-between bg-transparent py-1"
			>
				<div className="flex items-center gap-2">
					<span className="text-sm font-medium text-text-1">{label}</span>
					{!open && hint && <span className="text-xs text-text-4">{hint}</span>}
				</div>
				<ChevronDown
					size={14}
					className={cn(
						'text-text-4 transition-transform duration-150',
						open && 'rotate-180'
					)}
				/>
			</button>
			{open && <div className="pt-3">{children}</div>}
		</div>
	);
}
